import {
  ADD_CONTENT,
  EDIT_CONTENT,
  GET_CONTENT_FAILED,
  GET_CONTENT_SUCCESS,
  CONTENT_DELETE_SUCCESS,
  CONTENT_DELETE_REQUEST,
  CONTENT_FLAG_OFF,
  CONTENT_MOVE_TO_FOLDER,
  CONTENT_DESC_ORDER_BY_CREATEDAT,
  CONTENT_ASC_ORDER_BY_CREATEDAT,
  CONTENT_DESC_ORDER_BY_NAME,
  CONTENT_ASC_ORDER_BY_NAME,
  CHECKED_CONTENT,
  UNCHECKED_CONTENT,
  CHECKED_SINGLE_CONTENT,
  UNCHECKED_SINGLE_CONTENT,
  DELETE_BULK_CONTENT,
  RESTORE_FILES_REQUEST,
  RESTORE_FILES_SUCCESS,
  ADD_CONTENT_REQUEST,
  ADD_CONTENT_FAILED,
  GET_CONTENT_FROM_GOOGLE_DRIVE,
  PICKING_DATA_FROM_GOOGLE,
  UPLOAD_FAILED,
  CONTENT_MOVE_SUCCESS,
  CONTENT_MOVE_REQUEST,
  CONTENT_MOVE_FAILED,
  ADD_CONTENT_DUPLICATE_ERROR,
  CONTENT_FOLDER_PULL_SUCCESS,
  CONTENT_FOLDER_PULL_FAILED,
  GET_PLAYLISTS_BY_CONTENT_SUCCESS,
  GET_PLAYLISTS_BY_CONTENT_FAILED,
  EDIT_WIDGET,
  EDIT_WIDGET_FAILED,
  DUPLICATE_NAMES_ERROR,
  CONTENT_MOVE_ERROR,
  CLOSE_WIDGET_SYNC_PROMPT,
  SYNC_WIDGET_SCREENS_FAILED,
} from '../constant';
import { api, baseApi } from '../../api/endpoints';
import toast from 'react-hot-toast';
export const flagContentOff = () => {
  return async (dispatch) => {
    dispatch({
      type: CONTENT_FLAG_OFF,
      payload: '',
    });
  };
};

export const editContent = (new_data) => {
  return async (dispatch) => {
    console.log('Start edit content request before');
    dispatch({
      type: ADD_CONTENT_REQUEST,
      payload: '',
    });
    // console.log(obj);
    try {
      console.log('Start edit content request');
      const { data, status } = await api.post(`/content/contentedit`, new_data);
      if (status === 201) {
        if (data.content) {
          console.log('>>>>>>>>>> data in editContent=>', data.content);
          dispatch({ type: EDIT_CONTENT, payload: data });
          return data.content;
        } else {
          dispatch({
            type: ADD_CONTENT_FAILED,
            payload: '',
          });
        }
      }
    } catch (error) {
      dispatch({
        type: UPLOAD_FAILED,
        payload: error.response.data.toString(),
      });
    }
  };
};

export const closeContentDuplicateError = () => {
  return async (dispatch) => {
    dispatch({
      type: ADD_CONTENT_DUPLICATE_ERROR,
      payload: false,
    });
  };
};

export const addContentToState = (content) => {
  return async (dispatch) => {
    dispatch({
      type: ADD_CONTENT,
      payload: content,
    });
  };
};

export const addContent = (obj) => {
  // return async (dispatch) => {
  //   dispatch({
  //     type: ADD_CONTENT_REQUEST,
  //     payload: "",
  //   });
  //   console.log(obj)
  //   const {data} = await api.post('/content/getContentByName', {name: obj instanceof FormData ? obj.get("content").name :  obj.name, userId: obj instanceof FormData ? obj.get('user') : obj.user})
  //   const force = obj instanceof FormData ? obj.get("force") : obj.force
  //   if(data){
  //     if(!force && data.contentExists){
  //       dispatch({type: ADD_CONTENT_DUPLICATE_ERROR, payload: true})
  //     }else{
  //       dispatch({type: ADD_CONTENT_DUPLICATE_ERROR, payload: false})
  //       try {
  //         const { data, status } = await api.post(`/content/contentupload`, obj);
  //         if (status === 201) {
  //           if (data.content) {
  //             dispatch({ type: ADD_CONTENT, payload: data.content });
  //             return data.content;
  //           } else {
  //             dispatch({
  //               type: ADD_CONTENT_FAILED,
  //               payload: "",
  //             });
  //             throw new Error("Content creation failed without a response.");
  //           }
  //         }
  //       } catch (error) {
  //         dispatch({
  //           type: UPLOAD_FAILED,
  //           payload: JSON.stringify(error.response?.data) || error.message || "Unknown error",
  //         });
  //         throw error;
  //       }
  //     }
  //   }else{
  //     dispatch({
  //       type: UPLOAD_FAILED,
  //       payload: "Upload failed",
  //     });
  //   }
  // };
  // ---------------------------------------------------------
  // return async (dispatch) => {
  //   dispatch({
  //     type: START_UPLOAD_SPINNER
  //   })
  //   try{
  //     const filesArray = obj.getAll('content')
  //     const uploadURLs = []
  //     for await (const file of filesArray){
  //       const {data, status} = await api.post('/content/getpresignedurltoupload', {
  //         fileName: file.name
  //       })
  //       if(status == 200){
  //         uploadURLs.push(data)
  //       }
  //     }
  //     dispatch({
  //       type: END_UPLOAD_SPINNER
  //     })
  //     uploadURLs.forEach(urlObj => {
  //       dispatch({
  //         type: PROGRESS_BAR,
  //         payload: {
  //           name: urlObj.filename,
  //           progress: 0
  //         }
  //       })
  //       const xhr = new XMLHttpRequest()
  //       xhr.upload.addEventListener('progress', function(event) {
  //         if(event.lengthComputable) {
  //           const percentComplete = (event.loaded / event.total) * 100
  //           dispatch({
  //             type: PROGRESS_BAR,
  //             payload: {
  //               name: urlObj.filename,
  //               progress: percentComplete
  //             }
  //           })
  //         }
  //       })
  //       xhr.addEventListener('load', () => {
  //         if(xhr.status == 200) {
  //           // Wysłanie zapytania do bazy
  //         }
  //       })
  //       xhr.open('PUT', urlObj.url, true)
  //       xhr.send(filesArray.find(f => f.name == urlObj.filename).file)
  //     })
  //   }
  // }
};

export const addWidget = (obj) => {
  console.log('add widget=>', obj);
  return async (dispatch) => {
    dispatch({
      type: ADD_CONTENT_REQUEST,
      payload: '',
    });

    try {
      const { data, status } = await api.post(`/content/addwidgets`, obj);
      dispatch({ type: ADD_CONTENT, payload: [{ ...data.content }] });
      return data.content;
    } catch (error) {
      if (!error.response) return;

      if (error?.response?.data?.message == 'duplicate') {
        dispatch({
          type: DUPLICATE_NAMES_ERROR,
          payload: true,
        });

        setTimeout(() => {
          dispatch({
            type: DUPLICATE_NAMES_ERROR,
            payload: false,
          });
        }, 4000);
      } else {
        dispatch({
          type: DUPLICATE_NAMES_ERROR,
          payload: false,
        });
        const message = error?.response?.data?.error;
        if (message && [400, 422, 503].includes(error.response.status)) {
          toast.error(message);
        }
      }
    }
  };
};

export const editWidget = (obj) => {
  return async (dispatch) => {
    dispatch({
      type: ADD_CONTENT_REQUEST,
      payload: '',
    });

    try {
      const editRes = await api.post('/content/editwidget', obj);
      dispatch({
        type: EDIT_WIDGET,
        payload: editRes.data.widget,
      });
      return editRes.data.widget;
    } catch (error) {
      dispatch({
        type: EDIT_WIDGET_FAILED,
        payload: true,
      });
      setTimeout(() => {
        dispatch({
          type: EDIT_WIDGET_FAILED,
          payload: false,
        });
      }, 1000);
    }
  };
};

export const closeWidgetSyncPrompt = () => {
  return {
    type: CLOSE_WIDGET_SYNC_PROMPT,
  };
};

export const syncWidgetScreens = (contentId) => {
  return async (dispatch) => {
    try {
      const { data } = await api.post('/content/syncwidgetscreens', {
        contentId,
      });
      if (data?.delayed) {
        toast.success(
          `Sync scheduled for ${data.syncedScreensCount} screen(s)`,
        );
      } else {
        toast.success(`Sync started for ${data.syncedScreensCount} screen(s)`);
      }
    } catch (error) {
      dispatch({
        type: SYNC_WIDGET_SCREENS_FAILED,
        payload: true,
      });
    } finally {
      dispatch({
        type: CLOSE_WIDGET_SYNC_PROMPT,
      });
    }
  };
};

export const getContentById = (page, id) => {
  return async (dispatch) => {
    const content = await api.get(
      `/content/getcontents/${id}?${page ? 'page=' + page : ''}`,
    );
    if (content.status === 200) {
      if (content.data.content.length > -1) {
        dispatch({
          type: GET_CONTENT_SUCCESS,
          payload: content.data,
        });
      } else {
        dispatch({
          type: GET_CONTENT_FAILED,
          payload: '',
        });
      }
    }
  };
};
// const { page, name, sortType, sortDirection, contentType } = req.body

export const getContent = (
  page,
  query,
  sortType,
  sortDirection,
  contentType,
  folder,
) => {
  return async (dispatch) => {
    //   dispatch({
    //     type: GET_CONTENT_REQUEST,
    //     payload: "",
    //   });
    try {
      const content = await api.post(`/content/getcontents`, {
        page: page,
        name: query,
        sortType: sortType,
        sortDirection: sortDirection,
        contentType: contentType,
        folder: folder,
      });
      dispatch({
        type: GET_CONTENT_SUCCESS,
        payload: content.data,
      });
    } catch (error) {
      dispatch({
        type: GET_CONTENT_FAILED,
        payload: '',
      });
    }
  };
};
export const deleteContent = (id) => {
  return async (dispatch) => {
    dispatch({
      type: CONTENT_DELETE_REQUEST,
      payload: '',
    });
    const content = await api.patch(`/content/delete/${id}`);
    if (content.status === 201) {
      dispatch({
        type: CONTENT_DELETE_SUCCESS,
        payload: id,
      });
    }
  };
};
export const registerContentDelete = (id) => {
  return async (dispatch) => {
    dispatch({
      type: CONTENT_DELETE_SUCCESS,
      payload: id,
    });
  };
};
export const contentMoveToFolder = (obj) => {
  return async (dispatch) => {
    try {
      const content = await api.patch(
        `/content/contentmovetofolder/${obj.id}`,
        obj,
      );
      dispatch({
        type: CONTENT_MOVE_TO_FOLDER,
        payload: content.data.content,
      });
    } catch (error) {
      dispatch({
        type: CONTENT_MOVE_ERROR,
        payload: error?.response?.data?.message || error?.response?.data,
      });
      setTimeout(() => {
        dispatch({
          type: CONTENT_MOVE_ERROR,
          payload: '',
        });
      }, 1000);
    }
  };
};

export const contentDescByCreatedAt = () => {
  return async (dispatch) => {
    dispatch({
      type: CONTENT_DESC_ORDER_BY_CREATEDAT,
      payload: '',
    });
  };
};
export const contentAscByCreatedAt = () => {
  return async (dispatch) => {
    dispatch({
      type: CONTENT_ASC_ORDER_BY_CREATEDAT,
      payload: '',
    });
  };
};
export const contentDescByName = () => {
  return async (dispatch) => {
    dispatch({
      type: CONTENT_DESC_ORDER_BY_NAME,
      payload: '',
    });
  };
};
export const contentAscByName = () => {
  return async (dispatch) => {
    dispatch({
      type: CONTENT_ASC_ORDER_BY_NAME,
      payload: '',
    });
  };
};
export const checkedContent = (currentFolder) => {
  return async (dispatch) => {
    dispatch({
      type: CHECKED_CONTENT,
      payload: currentFolder,
    });
  };
};
export const unCheckedContent = (currentFolder) => {
  return async (dispatch) => {
    dispatch({
      type: UNCHECKED_CONTENT,
      payload: currentFolder,
    });
  };
};
export const checkedSingleContent = (id) => {
  return async (dispatch) => {
    dispatch({
      type: CHECKED_SINGLE_CONTENT,
      payload: id,
    });
  };
};
export const unCheckedSignleContent = (id) => {
  return async (dispatch) => {
    dispatch({
      type: UNCHECKED_SINGLE_CONTENT,
      payload: id,
    });
  };
};
export const deleteMultipleContent = (contentArray) => {
  return async (dispatch) => {
    console.log('from api calling=>', contentArray);
    dispatch({
      type: CONTENT_DELETE_REQUEST,
      payload: '',
    });
    const deleted = await api.patch('/content/multipledelete', {
      contentArray,
    });
    if (deleted.status === 201) {
      dispatch({
        type: DELETE_BULK_CONTENT,
        payload: contentArray,
      });
    }
  };
};
export const restoreFile = (id) => {
  return async (dispatch) => {
    dispatch({
      type: RESTORE_FILES_REQUEST,
      payload: '',
    });
    const content = await api.patch(`/content/filerestore/${id}`);
    if (content.status === 201) {
      dispatch({
        type: RESTORE_FILES_SUCCESS,
        payload: id,
      });
    }
  };
};
export const pickingDataFromGoogle = () => {
  return async (dispatch) => {
    dispatch({
      type: PICKING_DATA_FROM_GOOGLE,
      payload: '',
    });
  };
};
export const getContentFromGoogleDrive = (obj) => {
  return async (dispatch) => {
    const { status, data } = await api.post(
      '/content/addcontentfromsocialmedia',
      obj,
    );
    dispatch({
      type: GET_CONTENT_FROM_GOOGLE_DRIVE,
      payload: data.content,
    });
  };
};
export const pullContentFromFolder = (id, oldFolderId) => {
  return async (dispatch) => {
    try {
      const data = await api.post('/content/pullContentFromFolder', {
        id: id,
        oldFolderId: oldFolderId,
      });
      dispatch({
        type: CONTENT_FOLDER_PULL_SUCCESS,
        payload: data.data.content,
      });
    } catch (error) {
      dispatch({
        type: CONTENT_FOLDER_PULL_FAILED,
        payload: error?.response?.data?.message || error?.response?.data,
      });
      setTimeout(() => {
        dispatch({
          type: CONTENT_FOLDER_PULL_FAILED,
          payload: '',
        });
      }, 1000);
    }
  };
};
export const addContentFromGoogleDrive = (obj) => {
  return async (dispatch) => {
    dispatch({
      type: ADD_CONTENT_REQUEST,
      payload: '',
    });

    const { status, data } = await api.post(
      '/content/addcontentfromgoogledrive',
      obj,
    );

    if (status === 201) {
      if (data.content.length > 0) {
        dispatch({ type: ADD_CONTENT, payload: data.content });
      } else {
        dispatch({
          type: ADD_CONTENT_FAILED,
          payload: '',
        });
      }
    }
  };
};
export const addContentFromOneDrive = (obj) => {
  return async (dispatch) => {
    dispatch({
      type: ADD_CONTENT_REQUEST,
      payload: '',
    });

    const { status, data } = await api.post(
      '/content/addcontentfromonedrive',
      obj,
    );

    if (status === 201) {
      if (data.content.length > 0) {
        dispatch({ type: ADD_CONTENT, payload: data.content });
      } else {
        dispatch({
          type: ADD_CONTENT_FAILED,
          payload: '',
        });
      }
    }
  };
};

export const getPlaylistsByContent = (contentId) => {
  return async (dispatch) => {
    try {
      const { data } = await api.post('/playlist/getPlaylistsByContentId', {
        contentId: contentId,
      });
      const usage = {
        playlists: data.playlists || [],
        screens: data.screens || [],
      };
      dispatch({
        type: GET_PLAYLISTS_BY_CONTENT_SUCCESS,
        payload: {
          ...usage,
          contentId,
        },
      });
      return usage;
    } catch (error) {
      dispatch({
        type: GET_PLAYLISTS_BY_CONTENT_FAILED,
      });
      return null;
    }
  };
};
